import { render, staticRenderFns } from "./DirectionButton.vue?vue&type=template&id=33602014"
import script from "./DirectionButton.vue?vue&type=script&lang=js"
export * from "./DirectionButton.vue?vue&type=script&lang=js"
import style0 from "./DirectionButton.vue?vue&type=style&index=0&id=33602014&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33602014')) {
      api.createRecord('33602014', component.options)
    } else {
      api.reload('33602014', component.options)
    }
    module.hot.accept("./DirectionButton.vue?vue&type=template&id=33602014", function () {
      api.rerender('33602014', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/DirectionButton.vue"
export default component.exports